module.exports = __webpack_public_path__ + "static/about2-7c37e97091d89ee53288145fa9e01920.png";